<template>
<div>
    <div v-if="current_user.user_type == user_types.REAL">
        <update-real-user></update-real-user>
    </div>
    <div v-else-if="current_user.user_type == user_types.LEGAL">
        <update-legal-user></update-legal-user>
    </div>
</div>
</template>

<script>
import { userTypes } from '@/constants/userTypes';
import { mapGetters } from 'vuex';
import UpdateRealUser from './UpdateRealUser.vue';
import UpdateLegalUser from './UpdateLegalUser.vue';

export default {
    components: {
        UpdateRealUser,
        UpdateLegalUser,
    },
    data() {
        return {
            user_types: userTypes,
        }
    },
    computed: {
        ...mapGetters('user', [
            'current_user'
        ]),
    },
}
</script>
